// import { Progress } from "antd";
import logo from "../../Assets/images/logo.svg";
import Progress from "../Progress";
import Actions from "./Actions";

const Navbar = ({
  progress = 0,
  project,
  showCart,
  showHelp,
  showProfile,
  tracer,
  priceLoading,
}) => {
  return (
    <div className="navbar__wrapper">
      <div className="navbar__wrapper--row">
        <img src={logo} alt="" />
        <div className="navbar__wrapper--actions">
          <Actions
            project={project}
            showCart={showCart}
            showHelp={showHelp}
            showProfile={showProfile}
            tracer={tracer}
            priceLoading={priceLoading}
          />
        </div>
      </div>
      <Progress value={progress} />
    </div>
  );
};

Navbar.propTypes = {};

export default Navbar;
